export default __webpack_public_path__ + "static/media/sr.5a345f8e.svg";